import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, inject, Directive, signal, Optional, SkipSelf, Input, computed, TemplateRef, ContentChild, ElementRef, ViewContainerRef, forwardRef, ContentChildren, ViewChild } from '@angular/core';
import { TUI_IS_ANDROID } from '@taiga-ui/cdk/tokens';
import { tuiWithStyles, tuiCreateToken, tuiProvide, tuiPx, tuiDirectiveBinding } from '@taiga-ui/cdk/utils/miscellaneous';
import { TuiLabel } from '@taiga-ui/core/components/label';
import * as i3$1 from '@angular/common';
import { NgIf, DOCUMENT, CommonModule } from '@angular/common';
import { WA_NAVIGATOR } from '@ng-web-apis/common';
import * as i1$1 from '@taiga-ui/cdk/directives/native-validator';
import { TuiNativeValidator } from '@taiga-ui/cdk/directives/native-validator';
import * as i2$1 from '@taiga-ui/core/directives/appearance';
import { tuiAppearance, tuiAppearanceState, tuiAppearanceMode, tuiAppearanceFocus, TuiAppearance } from '@taiga-ui/core/directives/appearance';
import { NgControl } from '@angular/forms';
import { tuiInjectElement, tuiValue } from '@taiga-ui/cdk/utils/dom';
import * as i3 from '@taiga-ui/core/directives/items-handlers';
import { TuiWithItemsHandlers, TUI_ITEMS_HANDLERS } from '@taiga-ui/core/directives/items-handlers';
import { toSignal } from '@angular/core/rxjs-interop';
import { WaResizeObserver } from '@ng-web-apis/resize-observer';
import { EMPTY_QUERY } from '@taiga-ui/cdk/constants';
import { tuiQueryListChanges } from '@taiga-ui/cdk/observables';
import { tuiInjectId } from '@taiga-ui/cdk/services';
import { tuiFocusedIn } from '@taiga-ui/cdk/utils/focus';
import { tuiButtonOptionsProvider, TuiButton } from '@taiga-ui/core/components/button';
import * as i4 from '@taiga-ui/core/components/data-list';
import { tuiAsDataListHost, TuiWithOptionContent } from '@taiga-ui/core/components/data-list';
import * as i1 from '@taiga-ui/core/directives/dropdown';
import { tuiDropdown, TuiDropdownDirective, TuiDropdownOpen, tuiDropdownOpen, TuiDropdownFixed, TuiWithDropdownOpen } from '@taiga-ui/core/directives/dropdown';
import * as i2 from '@taiga-ui/core/directives/icons';
import { TuiWithIcons, TuiIcons } from '@taiga-ui/core/directives/icons';
import { TUI_COMMON_ICONS, TUI_CLEAR_WORD } from '@taiga-ui/core/tokens';
import { PolymorpheusOutlet } from '@taiga-ui/polymorpheus';
import { ReplaySubject, switchMap, startWith } from 'rxjs';
const _c0 = ["vcr"];
const _c1 = [[["input"]], [["select"]], [["textarea"]], [["label"]], "*", [["tui-icon"]]];
const _c2 = ["input", "select", "textarea", "label", "*", "tui-icon"];
const _c3 = a0 => ({
  $implicit: a0
});
function TuiTextfieldComponent_button_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function TuiTextfieldComponent_button_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.accessor == null ? null : ctx_r2.accessor.setValue(null));
    })("pointerdown.zoneless.prevent", function TuiTextfieldComponent_button_6_Template_button_pointerdown_zoneless_prevent_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.input == null ? null : ctx_r2.input.nativeElement == null ? null : ctx_r2.input.nativeElement.focus());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("iconStart", ctx_r2.icons.close);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.clear(), " ");
  }
}
function TuiTextfieldComponent_span_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r4 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", text_r4, " ");
  }
}
function TuiTextfieldComponent_span_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtemplate(1, TuiTextfieldComponent_span_10_ng_container_1_Template, 2, 1, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r2.content)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c3, ctx_r2.control == null ? null : ctx_r2.control.value));
  }
}
function TuiTextfieldComponent_input_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 8);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ctx_r2.computedFiller());
  }
}
const _c4 = ["tuiTextfield", ""];
const _c5 = a0 => [a0];
function TuiSelect_option_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.placeholder, "\n");
  }
}
function TuiSelect_ng_template_1_option_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r2, " ");
  }
}
function TuiSelect_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TuiSelect_ng_template_1_option_0_Template, 2, 2, "option", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction1(1, _c5, ctx_r0.stringified));
  }
}
let TuiSelectLikeStyles = /*#__PURE__*/(() => {
  class TuiSelectLikeStyles {
    static {
      this.ɵfac = function TuiSelectLikeStyles_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiSelectLikeStyles)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiSelectLikeStyles,
        selectors: [["ng-component"]],
        hostAttrs: [1, "tui-select-like"],
        decls: 0,
        vars: 0,
        template: function TuiSelectLikeStyles_Template(rf, ctx) {},
        styles: [".t-select-like{caret-color:transparent}\n", ".t-select-like:not(:disabled):not(:read-only){cursor:pointer}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TuiSelectLikeStyles;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiSelectLike = /*#__PURE__*/(() => {
  class TuiSelectLike {
    constructor() {
      this.isAndroid = inject(TUI_IS_ANDROID);
      this.nothing = tuiWithStyles(TuiSelectLikeStyles);
    }
    clear(element) {
      element.value = '';
    }
    prevent(event, element) {
      if (this.isAndroid) {
        event.preventDefault();
        element.focus();
      }
    }
    static {
      this.ɵfac = function TuiSelectLike_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiSelectLike)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiSelectLike,
        hostAttrs: ["inputmode", "none", "autocomplete", "off", 1, "t-select-like"],
        hostBindings: function TuiSelectLike_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("beforeinput", function TuiSelectLike_beforeinput_HostBindingHandler($event) {
              return $event.inputType.includes("delete") || $event.preventDefault();
            })("input.capture", function TuiSelectLike_input_capture_HostBindingHandler($event) {
              return ($event.inputType == null ? null : $event.inputType.includes("delete")) && ctx.clear($event.target);
            })("mousedown", function TuiSelectLike_mousedown_HostBindingHandler($event) {
              return ctx.prevent($event, $event.target);
            });
          }
        }
      });
    }
  }
  return TuiSelectLike;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DEFAULT = {
  appearance: 'textfield',
  size: 'l',
  cleaner: true
};
const TUI_TEXTFIELD_OPTIONS = tuiCreateToken({
  appearance: signal(DEFAULT.appearance),
  size: signal(DEFAULT.size),
  cleaner: signal(DEFAULT.cleaner)
});
function tuiTextfieldOptionsProvider(options) {
  return {
    provide: TUI_TEXTFIELD_OPTIONS,
    deps: [[new Optional(), new SkipSelf(), TUI_TEXTFIELD_OPTIONS]],
    useFactory: parent => ({
      appearance: signal(parent?.appearance() ?? DEFAULT.appearance),
      size: signal(parent?.size() ?? DEFAULT.size),
      cleaner: signal(parent?.cleaner() ?? DEFAULT.cleaner),
      ...options
    })
  };
}
let TuiTextfieldOptionsDirective = /*#__PURE__*/(() => {
  class TuiTextfieldOptionsDirective {
    constructor() {
      this.options = inject(TUI_TEXTFIELD_OPTIONS, {
        skipSelf: true
      });
      // TODO: refactor to signal inputs after Angular update
      this.appearance = signal(this.options.appearance());
      this.size = signal(this.options.size());
      this.cleaner = signal(this.options.cleaner());
    }
    set tuiTextfieldAppearance(appearance) {
      this.appearance.set(appearance);
    }
    set tuiTextfieldSize(size) {
      this.size.set(size);
    }
    set tuiTextfieldCleaner(enabled) {
      this.cleaner.set(enabled);
    }
    static {
      this.ɵfac = function TuiTextfieldOptionsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTextfieldOptionsDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiTextfieldOptionsDirective,
        selectors: [["", "tuiTextfieldAppearance", ""], ["", "tuiTextfieldSize", ""], ["", "tuiTextfieldCleaner", ""]],
        inputs: {
          tuiTextfieldAppearance: "tuiTextfieldAppearance",
          tuiTextfieldSize: "tuiTextfieldSize",
          tuiTextfieldCleaner: "tuiTextfieldCleaner"
        },
        features: [i0.ɵɵProvidersFeature([tuiProvide(TUI_TEXTFIELD_OPTIONS, TuiTextfieldOptionsDirective)])]
      });
    }
  }
  return TuiTextfieldOptionsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_TEXTFIELD_ACCESSOR = tuiCreateToken();
function tuiAsTextfieldAccessor(accessor) {
  return tuiProvide(TUI_TEXTFIELD_ACCESSOR, accessor);
}
const TUI_AUXILIARY = tuiCreateToken(null);
function tuiAsAuxiliary(x) {
  return tuiProvide(TUI_AUXILIARY, x);
}
function tuiInjectAuxiliary(predicate) {
  const {
    auxiliaries
  } = inject(TuiTextfieldComponent);
  return computed(() => auxiliaries().find(predicate) ?? null);
}
let TuiTextfieldDropdownDirective = /*#__PURE__*/(() => {
  class TuiTextfieldDropdownDirective {
    static {
      this.ɵfac = function TuiTextfieldDropdownDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTextfieldDropdownDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiTextfieldDropdownDirective,
        selectors: [["ng-template", "tuiTextfieldDropdown", ""]]
      });
    }
  }
  return TuiTextfieldDropdownDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiWithTextfieldDropdown = /*#__PURE__*/(() => {
  class TuiWithTextfieldDropdown {
    constructor() {
      this.dropdown = tuiDropdown(null);
    }
    set template(template) {
      this.dropdown.set(template);
    }
    static {
      this.ɵfac = function TuiWithTextfieldDropdown_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiWithTextfieldDropdown)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiWithTextfieldDropdown,
        contentQueries: function TuiWithTextfieldDropdown_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TuiTextfieldDropdownDirective, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.template = _t.first);
          }
        }
      });
    }
  }
  return TuiWithTextfieldDropdown;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTextfieldComponent = /*#__PURE__*/(() => {
  class TuiTextfieldComponent {
    constructor() {
      // TODO: refactor to signal inputs after Angular update
      this.filler = signal('');
      this.autoId = tuiInjectId();
      this.dropdown = inject(TuiDropdownDirective);
      this.dropdownOpen = inject(TuiDropdownOpen);
      this.open = tuiDropdownOpen();
      this.focusedIn = tuiFocusedIn(tuiInjectElement());
      this.contentReady$ = new ReplaySubject(1);
      this.inputQuery = signal(undefined);
      this.auxiliaryQuery = EMPTY_QUERY;
      this.icons = inject(TUI_COMMON_ICONS);
      this.clear = toSignal(inject(TUI_CLEAR_WORD));
      this.computedFiller = computed((value = this.value()) => {
        const filledValue = value + this.filler().slice(value.length);
        return filledValue.length > value.length ? filledValue : '';
      });
      this.showFiller = computed(() => this.focused() && !!this.computedFiller() && (!!this.value() || !this.input?.nativeElement.placeholder));
      this.focused = computed(() => this.open() || this.focusedIn());
      this.options = inject(TUI_TEXTFIELD_OPTIONS);
      this.el = tuiInjectElement();
      this.value = tuiValue(this.inputQuery);
      // TODO: Refactor to signal queries when Angular is updated
      this.auxiliaries = toSignal(this.contentReady$.pipe(switchMap(() => tuiQueryListChanges(this.auxiliaryQuery)), startWith([])), {
        requireSync: true
      });
    }
    set fillerSetter(filler) {
      this.filler.set(filler);
    }
    get id() {
      return this.input?.nativeElement.id || this.autoId;
    }
    get size() {
      return this.options.size();
    }
    ngAfterContentInit() {
      this.contentReady$.next(true);
      this.inputQuery.set(this.input);
    }
    handleOption(option) {
      this.accessor?.setValue(option);
      this.open.set(false);
    }
    get hasLabel() {
      return Boolean(this.label?.nativeElement?.childNodes.length);
    }
    onResize({
      contentRect
    }) {
      this.el.style.setProperty('--t-side', tuiPx(contentRect.width));
    }
    // Click on ::before,::after pseudo-elements ([iconStart] / [iconEnd])
    onIconClick(event) {
      if (event.target !== this.el || this.input?.nativeElement.matches(':read-only')) {
        return;
      }
      event.preventDefault();
      this.input?.nativeElement.focus({
        preventScroll: true
      });
      if (this.dropdownOpen.tuiDropdownEnabled && this.dropdown.content) {
        this.open.update(x => !x);
      }
    }
    static {
      this.ɵfac = function TuiTextfieldComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTextfieldComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiTextfieldComponent,
        selectors: [["tui-textfield"]],
        contentQueries: function TuiTextfieldComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TuiLabel, 5, ElementRef);
            i0.ɵɵcontentQuery(dirIndex, NgControl, 5);
            i0.ɵɵcontentQuery(dirIndex, TUI_TEXTFIELD_ACCESSOR, 5);
            i0.ɵɵcontentQuery(dirIndex, TuiTextfieldDirective, 7, ElementRef);
            i0.ɵɵcontentQuery(dirIndex, TUI_AUXILIARY, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.label = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.control = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accessor = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.auxiliaryQuery = _t);
          }
        },
        viewQuery: function TuiTextfieldComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vcr = _t.first);
          }
        },
        hostVars: 7,
        hostBindings: function TuiTextfieldComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mousedown", function TuiTextfieldComponent_mousedown_HostBindingHandler($event) {
              return ctx.onIconClick($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-size", ctx.options.size());
            i0.ɵɵclassProp("_with-label", ctx.hasLabel)("_with-template", ctx.content)("_disabled", ctx.input == null ? null : ctx.input.nativeElement.disabled);
          }
        },
        inputs: {
          content: "content",
          fillerSetter: [0, "filler", "fillerSetter"]
        },
        features: [i0.ɵɵProvidersFeature([tuiButtonOptionsProvider({
          size: 'xs',
          appearance: 'icon'
        }), tuiAsDataListHost(TuiTextfieldComponent)]), i0.ɵɵHostDirectivesFeature([i1.TuiDropdownDirective, i1.TuiDropdownFixed, i1.TuiWithDropdownOpen, i2.TuiWithIcons, i3.TuiWithItemsHandlers, i4.TuiWithOptionContent, TuiWithTextfieldDropdown])],
        ngContentSelectors: _c2,
        decls: 12,
        vars: 3,
        consts: [["vcr", ""], [1, "t-content", 3, "pointerdown.prevent", "waResizeObserver"], ["appearance", "icon", "size", "xs", "tabindex", "-1", "tuiIconButton", "", "type", "button", "class", "t-clear", 3, "iconStart", "click", "pointerdown.zoneless.prevent", 4, "ngIf"], ["class", "t-template", 4, "ngIf"], ["aria-hidden", "true", "disabled", "", "class", "t-filler", 3, "value", 4, "ngIf"], ["appearance", "icon", "size", "xs", "tabindex", "-1", "tuiIconButton", "", "type", "button", 1, "t-clear", 3, "click", "pointerdown.zoneless.prevent", "iconStart"], [1, "t-template"], [4, "polymorpheusOutlet", "polymorpheusOutletContext"], ["aria-hidden", "true", "disabled", "", 1, "t-filler", 3, "value"]],
        template: function TuiTextfieldComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵprojection(0);
            i0.ɵɵprojection(1, 1);
            i0.ɵɵprojection(2, 2);
            i0.ɵɵprojection(3, 3);
            i0.ɵɵelementStart(4, "span", 1);
            i0.ɵɵlistener("pointerdown.prevent", function TuiTextfieldComponent_Template_span_pointerdown_prevent_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.input == null ? null : ctx.input.nativeElement == null ? null : ctx.input.nativeElement.focus());
            })("waResizeObserver", function TuiTextfieldComponent_Template_span_waResizeObserver_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event[0] && ctx.onResize($event[0]));
            });
            i0.ɵɵprojection(5, 4);
            i0.ɵɵtemplate(6, TuiTextfieldComponent_button_6_Template, 2, 2, "button", 2);
            i0.ɵɵelementContainer(7, null, 0);
            i0.ɵɵprojection(9, 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, TuiTextfieldComponent_span_10_Template, 2, 4, "span", 3)(11, TuiTextfieldComponent_input_11_Template, 1, 1, "input", 4);
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", ctx.options.cleaner());
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", (ctx.control == null ? null : ctx.control.value) != null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showFiller());
          }
        },
        dependencies: [NgIf, PolymorpheusOutlet, TuiButton, WaResizeObserver],
        styles: ["tui-textfield{scrollbar-width:none;-ms-overflow-style:none;transition-property:color;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;--t-height: var(--tui-height-l);--t-padding: var(--tui-padding-l);position:relative;display:flex;flex-wrap:wrap;align-items:center;cursor:pointer;min-block-size:var(--t-height);color:var(--tui-text-tertiary);padding:0 var(--t-padding);border-radius:var(--tui-radius-l);font:var(--tui-font-text-ui-m);box-sizing:border-box;gap:0 .25rem}tui-textfield::-webkit-scrollbar,tui-textfield::-webkit-scrollbar-thumb{display:none}tui-textfield[style*=\"--t-icon-start:\"]{--t-left: 2.25rem}tui-textfield[style*=\"--t-icon-end:\"]{--t-right: 2.25rem}tui-textfield::-webkit-resizer{border:.25rem solid transparent;inline-size:.5rem;block-size:.5rem;box-sizing:content-box;color:var(--tui-text-tertiary);background:linear-gradient(-45deg,transparent,transparent .125rem,currentColor .125rem,currentColor .1875rem,transparent .1875rem,transparent .25rem,currentColor .25rem,currentColor .3125rem,transparent .35rem);background-clip:content-box}tui-textfield label,tui-textfield>.t-content,tui-textfield>.t-template{pointer-events:none}tui-textfield input,tui-textfield select,tui-textfield textarea{font:var(--tui-font-text-ui-m);resize:none;padding-block-start:1.125rem;padding-block-end:1.125rem}tui-textfield[data-size=s]{--t-height: var(--tui-height-s);--t-padding: var(--tui-padding-s);border-radius:var(--tui-radius-m);gap:0;font:var(--tui-font-text-ui-s)}tui-textfield[data-size=s][style*=\"--t-icon-start:\"]{--t-left: 1.25rem}tui-textfield[data-size=s][style*=\"--t-icon-end:\"]{--t-right: 1.25rem}tui-textfield[data-size=s]:before{margin:0 .5rem 0 -.125rem;font-size:1rem}tui-textfield[data-size=s]:after{margin:0 -.175rem 0 .575rem;font-size:1rem}tui-textfield[data-size=s] input,tui-textfield[data-size=s] select,tui-textfield[data-size=s] textarea{font:var(--tui-font-text-ui-s);padding-block-start:.5rem;padding-block-end:.5rem}tui-textfield[data-size=s]>.t-content{margin-inline-end:-.325rem}tui-textfield[data-size=m]{--t-height: var(--tui-height-m);--t-padding: var(--tui-padding-m);border-radius:var(--tui-radius-m);font:var(--tui-font-text-ui-s)}tui-textfield[data-size=m][style*=\"--t-icon-start:\"]{--t-left: 1.75rem}tui-textfield[data-size=m][style*=\"--t-icon-end:\"]{--t-right: 1.75rem}tui-textfield[data-size=m]:before{margin:0 .125rem 0 -.125rem}tui-textfield[data-size=m]:after{margin:0 -.125rem 0 .25rem}tui-textfield[data-size=m] input,tui-textfield[data-size=m] select,tui-textfield[data-size=m] textarea{font:var(--tui-font-text-ui-s);padding-block-start:.875rem;padding-block-end:.875rem}tui-textfield[data-size=m]>.t-content{margin-inline-end:-.125rem}tui-textfield:hover{color:var(--tui-text-secondary)}tui-textfield:hover:has(input:read-only),tui-textfield:hover:has(textarea:read-only),tui-textfield:hover:has(select[data-mode~=readonly]){color:var(--tui-text-tertiary)}tui-textfield:before{z-index:1;margin-inline-end:.5rem}tui-textfield:has(:disabled:not(.t-filler,button,option)):before,tui-textfield:has(:disabled:not(.t-filler,button,option)):after,tui-textfield:has(:disabled:not(.t-filler,button,option))>.t-template{opacity:var(--tui-disabled-opacity)}tui-textfield._disabled:before,tui-textfield._disabled:after,tui-textfield._disabled>.t-template{opacity:var(--tui-disabled-opacity)}tui-textfield:has(label:not(:empty))>.t-template,tui-textfield:has(label:not(:empty)) input:not([type=range]),tui-textfield:has(label:not(:empty)) select:defined,tui-textfield:has(label:not(:empty)) textarea:defined{padding-block-start:calc(var(--t-height) / 3);padding-block-end:0}tui-textfield:has(label:not(:empty))>.t-template::placeholder,tui-textfield:has(label:not(:empty)) input:not([type=range])::placeholder,tui-textfield:has(label:not(:empty)) select:defined::placeholder,tui-textfield:has(label:not(:empty)) textarea:defined::placeholder,tui-textfield:has(label:not(:empty))>.t-template._empty,tui-textfield:has(label:not(:empty)) input:not([type=range])._empty,tui-textfield:has(label:not(:empty)) select:defined._empty,tui-textfield:has(label:not(:empty)) textarea:defined._empty{color:transparent}tui-textfield._with-label>.t-template,tui-textfield._with-label input:not([type=range]),tui-textfield._with-label select:defined,tui-textfield._with-label textarea:defined{padding-top:calc(var(--t-height) / 3);padding-block-end:0}tui-textfield._with-label>.t-template::placeholder,tui-textfield._with-label input:not([type=range])::placeholder,tui-textfield._with-label select:defined::placeholder,tui-textfield._with-label textarea:defined::placeholder,tui-textfield._with-label>.t-template._empty,tui-textfield._with-label input:not([type=range])._empty,tui-textfield._with-label select:defined._empty,tui-textfield._with-label textarea:defined._empty{color:transparent}tui-textfield>.t-template,tui-textfield input:defined,tui-textfield select:defined,tui-textfield textarea:defined{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;-webkit-appearance:none;appearance:none;box-sizing:border-box;border-radius:inherit;border-width:0;overscroll-behavior:none;padding-inline-start:calc(var(--t-left, 0rem) + var(--t-padding));padding-inline-end:calc(var(--t-right, 0rem) + var(--t-side) + var(--t-padding))}tui-textfield>.t-template{display:flex;align-items:center;color:var(--tui-text-primary)}tui-textfield._with-template input:not([type=range]),tui-textfield._with-template select,tui-textfield._with-template textarea{color:transparent!important}tui-textfield input:not([type=range]),tui-textfield select:defined,tui-textfield textarea:defined{pointer-events:auto;background:transparent}tui-textfield input:not([type=range]):read-only~.t-filler,tui-textfield select:defined:read-only~.t-filler,tui-textfield textarea:defined:read-only~.t-filler{display:none}tui-textfield input:not([type=range]):disabled~label,tui-textfield select:defined:disabled~label,tui-textfield textarea:defined:disabled~label,tui-textfield input:not([type=range]):disabled~.t-content,tui-textfield select:defined:disabled~.t-content,tui-textfield textarea:defined:disabled~.t-content{opacity:var(--tui-disabled-opacity)}tui-textfield input:not([type=range]):disabled~label>tui-icon,tui-textfield select:defined:disabled~label>tui-icon,tui-textfield textarea:defined:disabled~label>tui-icon,tui-textfield input:not([type=range]):disabled~.t-content>tui-icon,tui-textfield select:defined:disabled~.t-content>tui-icon,tui-textfield textarea:defined:disabled~.t-content>tui-icon{display:none}tui-textfield input:not([type=range]):-webkit-autofill~label,tui-textfield select:defined:-webkit-autofill~label,tui-textfield textarea:defined:-webkit-autofill~label,tui-textfield input:not([type=range]):not(._empty):not(:placeholder-shown)~label,tui-textfield select:defined:not(._empty):not(:placeholder-shown)~label,tui-textfield textarea:defined:not(._empty):not(:placeholder-shown)~label{font-size:.83em;transform:translateY(-.7em)}tui-textfield input:not([type=range]):-webkit-autofill:not(:disabled)[data-mode~=invalid]~label,tui-textfield select:defined:-webkit-autofill:not(:disabled)[data-mode~=invalid]~label,tui-textfield textarea:defined:-webkit-autofill:not(:disabled)[data-mode~=invalid]~label,tui-textfield input:not([type=range]):not(._empty):not(:placeholder-shown):not(:disabled)[data-mode~=invalid]~label,tui-textfield select:defined:not(._empty):not(:placeholder-shown):not(:disabled)[data-mode~=invalid]~label,tui-textfield textarea:defined:not(._empty):not(:placeholder-shown):not(:disabled)[data-mode~=invalid]~label,tui-textfield input:not([type=range]):-webkit-autofill:invalid:not(:disabled):not([data-mode])~label,tui-textfield select:defined:-webkit-autofill:invalid:not(:disabled):not([data-mode])~label,tui-textfield textarea:defined:-webkit-autofill:invalid:not(:disabled):not([data-mode])~label,tui-textfield input:not([type=range]):not(._empty):not(:placeholder-shown):invalid:not(:disabled):not([data-mode])~label,tui-textfield select:defined:not(._empty):not(:placeholder-shown):invalid:not(:disabled):not([data-mode])~label,tui-textfield textarea:defined:not(._empty):not(:placeholder-shown):invalid:not(:disabled):not([data-mode])~label{color:var(--tui-text-negative)}tui-textfield input:not([type=range]):-webkit-autofill:not(:disabled):not([data-mode~=readonly])~.t-content .t-clear,tui-textfield select:defined:-webkit-autofill:not(:disabled):not([data-mode~=readonly])~.t-content .t-clear,tui-textfield textarea:defined:-webkit-autofill:not(:disabled):not([data-mode~=readonly])~.t-content .t-clear,tui-textfield input:not([type=range]):not(._empty):not(:placeholder-shown):not(:disabled):not([data-mode~=readonly])~.t-content .t-clear,tui-textfield select:defined:not(._empty):not(:placeholder-shown):not(:disabled):not([data-mode~=readonly])~.t-content .t-clear,tui-textfield textarea:defined:not(._empty):not(:placeholder-shown):not(:disabled):not([data-mode~=readonly])~.t-content .t-clear{display:flex}tui-textfield input:not([type=range]):not([data-mode~=readonly]):focus-visible:not([data-focus=false])::placeholder,tui-textfield select:defined:not([data-mode~=readonly]):focus-visible:not([data-focus=false])::placeholder,tui-textfield textarea:defined:not([data-mode~=readonly]):focus-visible:not([data-focus=false])::placeholder,tui-textfield input:not([type=range]):not([data-mode~=readonly]):focus-visible:not([data-focus=false])._empty,tui-textfield select:defined:not([data-mode~=readonly]):focus-visible:not([data-focus=false])._empty,tui-textfield textarea:defined:not([data-mode~=readonly]):focus-visible:not([data-focus=false])._empty{color:var(--tui-text-tertiary)}tui-textfield input:not([type=range]):not([data-mode~=readonly]):focus-visible:not([data-focus=false])~label,tui-textfield select:defined:not([data-mode~=readonly]):focus-visible:not([data-focus=false])~label,tui-textfield textarea:defined:not([data-mode~=readonly]):focus-visible:not([data-focus=false])~label{color:var(--tui-text-primary)!important;font-size:.83em;transform:translateY(-.7em)}tui-textfield input:not([type=range]):not([data-mode~=readonly])[data-focus=true]::placeholder,tui-textfield select:defined:not([data-mode~=readonly])[data-focus=true]::placeholder,tui-textfield textarea:defined:not([data-mode~=readonly])[data-focus=true]::placeholder,tui-textfield input:not([type=range]):not([data-mode~=readonly])[data-focus=true]._empty,tui-textfield select:defined:not([data-mode~=readonly])[data-focus=true]._empty,tui-textfield textarea:defined:not([data-mode~=readonly])[data-focus=true]._empty{color:var(--tui-text-tertiary)}tui-textfield input:not([type=range]):not([data-mode~=readonly])[data-focus=true]~label,tui-textfield select:defined:not([data-mode~=readonly])[data-focus=true]~label,tui-textfield textarea:defined:not([data-mode~=readonly])[data-focus=true]~label{color:var(--tui-text-primary)!important;font-size:.83em;transform:translateY(-.7em)}tui-textfield input:not([type=range]):not([data-mode~=readonly])[tuiWrapper]:not(._focused):has(:focus-visible)::placeholder,tui-textfield select:defined:not([data-mode~=readonly])[tuiWrapper]:not(._focused):has(:focus-visible)::placeholder,tui-textfield textarea:defined:not([data-mode~=readonly])[tuiWrapper]:not(._focused):has(:focus-visible)::placeholder,tui-textfield input:not([type=range]):not([data-mode~=readonly])[tuiWrapper]._focused::placeholder,tui-textfield select:defined:not([data-mode~=readonly])[tuiWrapper]._focused::placeholder,tui-textfield textarea:defined:not([data-mode~=readonly])[tuiWrapper]._focused::placeholder,tui-textfield input:not([type=range]):not([data-mode~=readonly])[tuiWrapper]:not(._focused):has(:focus-visible)._empty,tui-textfield select:defined:not([data-mode~=readonly])[tuiWrapper]:not(._focused):has(:focus-visible)._empty,tui-textfield textarea:defined:not([data-mode~=readonly])[tuiWrapper]:not(._focused):has(:focus-visible)._empty,tui-textfield input:not([type=range]):not([data-mode~=readonly])[tuiWrapper]._focused._empty,tui-textfield select:defined:not([data-mode~=readonly])[tuiWrapper]._focused._empty,tui-textfield textarea:defined:not([data-mode~=readonly])[tuiWrapper]._focused._empty{color:var(--tui-text-tertiary)}tui-textfield input:not([type=range]):not([data-mode~=readonly])[tuiWrapper]:not(._focused):has(:focus-visible)~label,tui-textfield select:defined:not([data-mode~=readonly])[tuiWrapper]:not(._focused):has(:focus-visible)~label,tui-textfield textarea:defined:not([data-mode~=readonly])[tuiWrapper]:not(._focused):has(:focus-visible)~label,tui-textfield input:not([type=range]):not([data-mode~=readonly])[tuiWrapper]._focused~label,tui-textfield select:defined:not([data-mode~=readonly])[tuiWrapper]._focused~label,tui-textfield textarea:defined:not([data-mode~=readonly])[tuiWrapper]._focused~label{color:var(--tui-text-primary)!important;font-size:.83em;transform:translateY(-.7em)}@supports (-webkit-touch-callout: none){tui-textfield input:not([type=range])._ios-fix,tui-textfield select:defined._ios-fix,tui-textfield textarea:defined._ios-fix{position:fixed;left:1000rem}}tui-textfield [tuiLabel][tuiLabel][tuiLabel]{transition-property:all;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;position:relative;display:block;flex:1;align-self:flex-start;font-size:inherit;line-height:var(--t-height)}tui-textfield label:defined,tui-textfield input:defined::placeholder,tui-textfield textarea:defined::placeholder,tui-textfield select:defined._empty{color:var(--tui-text-secondary)}tui-textfield select:not([data-mode~=readonly]){cursor:pointer}tui-textfield select option[value=\"\"]:disabled{color:transparent}tui-textfield select optgroup,tui-textfield select option{background-color:var(--tui-background-elevation-3)}tui-textfield select optgroup,tui-textfield select option:not(:disabled){color:var(--tui-text-primary)}tui-textfield button,tui-textfield a{pointer-events:auto}tui-textfield>.t-content{display:flex;block-size:var(--t-height);align-items:center;gap:inherit;margin-inline-start:auto;isolation:isolate;border-radius:inherit}tui-textfield>.t-content>tui-icon{pointer-events:auto}tui-textfield textarea~.t-content{min-inline-size:.5rem}tui-textfield .t-clear{z-index:1;display:none;pointer-events:auto}tui-textfield>.t-filler:defined{pointer-events:none;background:none;color:var(--tui-text-tertiary);opacity:1}tui-textfield [tuiFluidTypography]{font-weight:700}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TuiTextfieldComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTextfieldBase = /*#__PURE__*/(() => {
  class TuiTextfieldBase {
    constructor() {
      // TODO: refactor to signal inputs after Angular update
      this.focused = signal(null);
      this.control = inject(NgControl, {
        optional: true
      });
      this.a = tuiAppearance(inject(TUI_TEXTFIELD_OPTIONS).appearance);
      this.s = tuiAppearanceState(null);
      this.m = tuiAppearanceMode(this.mode);
      this.f = tuiAppearanceFocus(computed(() => this.focused() ?? this.textfield.focused()));
      this.el = tuiInjectElement();
      this.itemsHandlers = inject(TUI_ITEMS_HANDLERS);
      this.textfield = inject(TuiTextfieldComponent);
      this.readOnly = false;
      this.invalid = null;
      this.value = tuiValue(this.el);
    }
    set focusedSetter(focused) {
      this.focused.set(focused);
    }
    set stateSetter(state) {
      this.s.set(state);
    }
    get mode() {
      if (this.readOnly) {
        return 'readonly';
      }
      if (this.invalid === false) {
        return 'valid';
      }
      if (this.invalid) {
        return 'invalid';
      }
      return null;
    }
    // TODO: refactor to signal inputs after Angular update
    ngOnChanges() {
      this.m.set(this.mode);
    }
    setValue(value) {
      this.el.focus();
      this.el.select();
      if (value == null) {
        this.el.ownerDocument.execCommand('delete');
      } else {
        this.el.ownerDocument.execCommand('insertText', false, this.itemsHandlers.stringify()(value));
      }
    }
    static {
      this.ɵfac = function TuiTextfieldBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTextfieldBase)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiTextfieldBase,
        inputs: {
          readOnly: "readOnly",
          invalid: "invalid",
          focusedSetter: [0, "focused", "focusedSetter"],
          stateSetter: [0, "state", "stateSetter"]
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return TuiTextfieldBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiTextfieldDirective = /*#__PURE__*/(() => {
  class TuiTextfieldDirective extends TuiTextfieldBase {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiTextfieldDirective_BaseFactory;
        return function TuiTextfieldDirective_Factory(__ngFactoryType__) {
          return (ɵTuiTextfieldDirective_BaseFactory || (ɵTuiTextfieldDirective_BaseFactory = i0.ɵɵgetInheritedFactory(TuiTextfieldDirective)))(__ngFactoryType__ || TuiTextfieldDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiTextfieldDirective,
        selectors: [["input", "tuiTextfield", "", 3, "tuiInputCard", "", 3, "tuiInputExpire", "", 3, "tuiInputCVC", ""]],
        hostVars: 4,
        hostBindings: function TuiTextfieldDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function TuiTextfieldDirective_input_HostBindingHandler() {
              return 0;
            })("focusin", function TuiTextfieldDirective_focusin_HostBindingHandler() {
              return 0;
            })("focusout", function TuiTextfieldDirective_focusout_HostBindingHandler() {
              return 0;
            });
          }
          if (rf & 2) {
            i0.ɵɵdomProperty("id", ctx.textfield.id)("readOnly", ctx.readOnly);
            i0.ɵɵclassProp("_empty", ctx.value() === "");
          }
        },
        features: [i0.ɵɵProvidersFeature([tuiAsTextfieldAccessor(TuiTextfieldDirective)]), i0.ɵɵHostDirectivesFeature([i1$1.TuiNativeValidator, i2$1.TuiAppearance]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return TuiTextfieldDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiWithTextfield = /*#__PURE__*/(() => {
  class TuiWithTextfield {
    static {
      this.ɵfac = function TuiWithTextfield_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiWithTextfield)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiWithTextfield,
        features: [i0.ɵɵHostDirectivesFeature([{
          directive: TuiTextfieldDirective,
          inputs: ["invalid", "invalid", "focused", "focused", "readOnly", "readOnly", "state", "state"]
        }])]
      });
    }
  }
  return TuiWithTextfield;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @deprecated use {@link TuiSelect} from @taiga-ui/kit instead
 */
let TuiSelect = /*#__PURE__*/(() => {
  class TuiSelect extends TuiTextfieldBase {
    constructor() {
      super(...arguments);
      this.nav = inject(WA_NAVIGATOR);
      this.doc = inject(DOCUMENT);
      this.placeholder = '';
    }
    setValue(value) {
      this.control?.control?.setValue(value);
      this.el.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
    focus() {
      this.el.classList.add('_ios-fix');
      this.el.focus();
      this.el.classList.remove('_ios-fix');
    }
    get ariaLabel() {
      return this.doc.querySelector(`label[for="${this.el.id}"]`) ? null : this.el.getAttribute('aria-label') || this.placeholder;
    }
    get stringified() {
      return this.itemsHandlers.stringify()(this.control?.value ?? '');
    }
    async onCopy() {
      await this.nav.clipboard.writeText(this.stringified);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTuiSelect_BaseFactory;
        return function TuiSelect_Factory(__ngFactoryType__) {
          return (ɵTuiSelect_BaseFactory || (ɵTuiSelect_BaseFactory = i0.ɵɵgetInheritedFactory(TuiSelect)))(__ngFactoryType__ || TuiSelect);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiSelect,
        selectors: [["select", "tuiTextfield", ""]],
        hostVars: 4,
        hostBindings: function TuiSelect_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("input", function TuiSelect_input_HostBindingHandler() {
              return 0;
            })("focusin", function TuiSelect_focusin_HostBindingHandler() {
              return 0;
            })("focusout", function TuiSelect_focusout_HostBindingHandler() {
              return 0;
            })("keydown.space.prevent", function TuiSelect_keydown_space_prevent_HostBindingHandler() {
              return 0;
            })("keydown.enter.prevent", function TuiSelect_keydown_enter_prevent_HostBindingHandler() {
              return 0;
            })("keydown.backspace", function TuiSelect_keydown_backspace_HostBindingHandler() {
              return ctx.setValue("");
            })("mousedown.prevent", function TuiSelect_mousedown_prevent_HostBindingHandler() {
              return ctx.focus();
            })("keydown.control.c", function TuiSelect_keydown_control_c_HostBindingHandler() {
              return ctx.onCopy();
            })("keydown.meta.c", function TuiSelect_keydown_meta_c_HostBindingHandler() {
              return ctx.onCopy();
            });
          }
          if (rf & 2) {
            i0.ɵɵdomProperty("id", ctx.textfield.id);
            i0.ɵɵattribute("aria-label", ctx.ariaLabel);
            i0.ɵɵclassProp("_empty", ctx.stringified === "");
          }
        },
        inputs: {
          placeholder: "placeholder"
        },
        features: [i0.ɵɵProvidersFeature([tuiAsTextfieldAccessor(TuiSelect)]), i0.ɵɵHostDirectivesFeature([i1$1.TuiNativeValidator, i2$1.TuiAppearance]), i0.ɵɵInheritDefinitionFeature],
        attrs: _c4,
        decls: 3,
        vars: 2,
        consts: [["selected", ""], ["disabled", "", "selected", "", "value", "", 4, "ngIf", "ngIfElse"], ["disabled", "", "selected", "", "value", ""], ["selected", "", 3, "value", 4, "ngFor", "ngForOf"], ["selected", "", 3, "value"]],
        template: function TuiSelect_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TuiSelect_option_0_Template, 2, 1, "option", 1)(1, TuiSelect_ng_template_1_Template, 1, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const selected_r3 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", ctx.placeholder && !ctx.stringified)("ngIfElse", selected_r3);
          }
        },
        dependencies: [CommonModule, i3$1.NgForOf, i3$1.NgIf],
        encapsulation: 2
      });
    }
  }
  return TuiSelect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TuiTextfield = [TuiLabel, TuiSelect, TuiTextfieldComponent, TuiTextfieldDirective, TuiTextfieldOptionsDirective, TuiTextfieldDropdownDirective];
let TuiTextfieldContent = /*#__PURE__*/(() => {
  class TuiTextfieldContent {
    constructor() {
      this.ref = inject(TuiTextfieldComponent).vcr?.createEmbeddedView(inject(TemplateRef));
    }
    ngDoCheck() {
      this.ref?.detectChanges();
    }
    static {
      this.ɵfac = function TuiTextfieldContent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiTextfieldContent)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TuiTextfieldContent,
        selectors: [["ng-template", "tuiTextfieldContent", ""]]
      });
    }
  }
  return TuiTextfieldContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function tuiTextfieldIconBinding(token) {
  const textfield = inject(TUI_TEXTFIELD_OPTIONS);
  const options = inject(token);
  return tuiDirectiveBinding(TuiIcons, 'iconEnd', computed(() => options.icon(textfield.size())), {});
}

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_AUXILIARY, TUI_TEXTFIELD_ACCESSOR, TUI_TEXTFIELD_OPTIONS, TuiSelect, TuiSelectLike, TuiTextfield, TuiTextfieldBase, TuiTextfieldComponent, TuiTextfieldContent, TuiTextfieldDirective, TuiTextfieldDropdownDirective, TuiTextfieldOptionsDirective, TuiWithTextfield, TuiWithTextfieldDropdown, tuiAsAuxiliary, tuiAsTextfieldAccessor, tuiInjectAuxiliary, tuiTextfieldIconBinding, tuiTextfieldOptionsProvider };
